
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Consultant (Finance & Accounts)  
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">



         

        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Qualifications and experience : </h3>
              <p><strong>Graduation</strong>(Bachelor  degree (B.Com/Equivalent) from any recognized university )   with 2 to 3 experience in relevant field,</p><strong> Or</strong> <br>
              <p><strong>Master degree</strong> (M.Com/Equivalent from any recognized university /MBA – Finance / PGDM- Finance. ) –with 1 to 2 experience in relevant field</p> <br>
                <p> Post qualification experience, with exposure to Government/ PSU/Bank accounting system and audit knowledge</p>
            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Age limit: </h3>
              <p> Candidates should be below 40 years of age as on the date of advertisement
</p>

            </div>
          </div>
        </div>
        <!-- feature box close -->


<!-- feature box begin -->
        <!-- <div class="col-md-12 mb40 sq-item wow sq-item wow">
          <div class="feature-box style-2 left">
            <i class="fa fa-graduation-cap"></i>
            <div class="text para_cls">
              <h3>Vacancy: </h3>
              <p> 1- Post
</p>

            </div>
          </div>
        </div> -->
        <!-- feature box close -->


  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p><strong>Rs. 40,000/- to 50,000/-per month</strong> consolidated  </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 07th August 2024 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->
<!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Required Proficiency </h3>
		<!-- <p>5+ year experience as Senior Manager/ Senior Project Manager desirable</p> -->
        <p> <span class="step_no">1</span>Proficiency in all Microsoft Office applications</p>
        <p> <span class="step_no">2</span>Proven work experience in the relevant field </p>
        <p> <span class="step_no">3</span>Hands-on experience with accounting software (Tally etc.)  and statistical packages</p>
		<p> <span class="step_no">4</span>Excellent analytical skills, along with the ability to create detailed reports spreadsheets, similar documents </p>
        <p> <span class="step_no">5</span>Good communication and interpersonal skills</p>
        <p> <span class="step_no">6</span>Possess finishing skills towards work</p>



      </div>
    </div>
  </div>
  <!-- feature box close -->

<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key Responsibilities</h3>        
<p><span class="step_no">1</span>All matters related to finance and accounts  of NIMI</p>
<p><span class="step_no">2</span>Budget Planning and Analysis</p>
<p><span class="step_no">3</span>Monitoring Budgeted expenditure of Heads/Subheads and implementing actions</p>
<p><span class="step_no">4</span>Annual audit</p>
<p><span class="step_no">5</span>Income Tax matters/filing of returns</p>
<p><span class="step_no">6</span>TDS and GST</p>
<p><span class="step_no">7</span>Liaisoning with Banks and Fund Managers</p>
<p><span class="step_no">8</span>Book-keeping</p>
<p><span class="step_no">9</span>Bank Reconciliation Statements</p>
<p><span class="step_no">10</span>Preparation and follow up of Minutes of Meetings and other instructions of NIMI</p>
<p><span class="step_no">11</span>Drafting and Analysis of Funding and other financial Agreements/ Documents</p>
<p><span class="step_no">12</span>Any other work assigned by NIMI within domain knowledge</p>
<p><span class="step_no">13</span>Assess financial status of NIMI periodically</p>
<p><span class="step_no">14</span>Analyze and develop investment plans for the funds available with NIMI</p>
<p><span class="step_no">15</span>Forecast budget, revenues and costs related to NIMI and report any discrepancies</p>
<p><span class="step_no">16</span>Manage current and future statutory payments pertaining to NIMI</p>
<p><span class="step_no">17</span>Monitor financial procedures and ensure compliance with respect to autonomous bodies</p>
<p><span class="step_no">18</span>Review day-to-day transactions of NIMI</p>
<p><span class="step_no">19</span>Identify areas of improvement</p>
      </div>
    </div>
  </div>
  <!-- feature box close -->


  <!-- feature box begin -->
   <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-cogs"></i>
      <div class="text para_cls">
        <h3>Key responsibility:</h3>
		
        <p> <span class="step_no">1</span>Managing content development</p>
        <p> <span class="step_no">2</span>Resolving client queries and problems.</p>
         <p> <span class="step_no">3</span>Managing and guiding junior consultants</p>
		<p> <span class="step_no">4</span>Supporting business development activities</p>
        <p> <span class="step_no">5</span>Performing financial analyses</p>
        <p> <span class="step_no">6</span>Assessing computing needs, shortcomings,and requirements.</p>
        <p> <span class="step_no">7</span>Overseeing daily operations within the department</p>

      </div>
    </div>
  </div> -->
  <!-- feature box close -->

    <!-- feature box begin -->
    <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Key responsibilities:</h3>
        
			
<p><span class="step_no">1</span>Design, implement and Support financial management systems and procedures
</p>
<p><span class="step_no">2</span>Ensure fulfil1ment of requirements as laid under the financial management manual of SANKALP</p>
<p><span class="step_no">3</span>Prepare necessary financial reports including budget preparation, maintaining books of accounts, statement of expenditure etc.</p>
<p><span class="step_no">4</span>Support MSDE and other	stakeholders for fulfilling	audit requirements of SANKALP</p>
<p><span class="step_no">5</span>Support in bringing collaboration and partnership with various stakeholders.</p>
<p><span class="step_no">6</span>Develop periodic reports as per MSDE requirements</p>
<p><span class="step_no">7</span>Any other work as per MSDE requirement.</p>

    
          </div>
        </div>
      </div> -->
      <!-- feature box close -->

          <!-- feature box begin -->
 <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Contract Duration :</h3>
            <p>Candidates selected will be engaged purely on contract basis initially for a period of1 year (extendable based on performance)</p>   
   
          </div>
        </div>
      </div> 
      <!-- feature box close -->

 <!-- feature box begin -->
     <div class="col-md-12 feature-box mb40 sq-item wow">
        <div class="feature-box style-2 left">
          <i class="fa fa-cogs"></i>
          <div class="text para_cls">
            <h3>Mode of Recruitment:</h3>
            <p>Contractual</p>        

    
          </div>
        </div>
      </div>
      <!-- feature box close -->
    
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Location</h3>
       		<p>02-Post NIMI, Chennai </p>

      </div>
    </div>
  </div>

<!-- feature box begin -->
<div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Short listed candidates will be called for Interview</p>
		<p><span class="step_no">2</span>Selected candidate has to enter an agreement with NIMI as per set guidelines.</p>
		<!-- <p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p> -->

      </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box close -->

 <!-- feature box begin -->
 <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Notification</h3>
       		<p><a href="assets/pdf/SANKALP_SENIOR_CONSULTANT_1.pdf" target="_blank">Click here to download</a></p>





      </div>
    </div>
  </div> -->
  <!-- feature box close -->


  


  <!-- <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div>  -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>



